import React from 'react';
import ReactDOM from 'react-dom/client';
import {IntlProvider} from 'react-intl';

const currentLanguage = document.getElementsByTagName('html')[0].lang || 'en';
const {default: messages} = require(`config/${process.env.REACT_APP_SITE}/i18n/${currentLanguage}.js`);
const {default: blocks} = require(`config/${process.env.REACT_APP_SITE}/blocks.config.js`);

window.initReact = () => {
  Object.keys(blocks).forEach((id) => {
    const element = document.getElementById(id);
    let props = element?.dataset;

    if (props) {
      Object.entries(props).forEach(([key, value]) => {
        try {
          props[key] = JSON.parse(value);
        }
        catch (e) {
          props[key] = value;
        }
      });
    }

    if (element) {
      const root = ReactDOM.createRoot(element);
      const Component = blocks[id];

      root.render(
        <React.StrictMode>
          <IntlProvider defaultLocale='en' locale={currentLanguage} messages={messages}>
            <Component currentLanguage={currentLanguage} {...props} />
          </IntlProvider>
        </React.StrictMode>
      );
    }
  });
};

window.initReact();
